(function() {
  var scriptElement = document.currentScript || document.getElementById("cu-candyrack-social-proof-script");
  var pageType = scriptElement ? scriptElement.getAttribute("data-page-type") : "";
  if (pageType !== "product") return;
  var MESSAGE = scriptElement ? (scriptElement.getAttribute("data-social-proof-message") || "").trim() : "";
  if (!MESSAGE) return;
  var PROOF_CLASS = "cu-candyrack-social-proof";
  var PAGE_PROOF_CLASS = "cu-candyrack-proof-chip";
  var FRAME_OFFER_CLASS = "cu-candyrack-frame-offer";
  var FRAME_PROOF_CLASS = "cu-candyrack-frame-proof";
  var PAGE_STYLE_ID = "cu-candyrack-social-proof-page-style";
  var STYLE_ID = "cu-candyrack-social-proof-popup-style";
  var scrollUnlockTimer = null;
  var scrollUnlockAttempts = 0;
  var lastCandyRackScrollY = 0;

  function ensurePageStyle() {
    if (!document.head) return;

    var style = document.getElementById(PAGE_STYLE_ID);
    if (!style) {
      style = document.createElement("style");
      style.id = PAGE_STYLE_ID;
      document.head.appendChild(style);
    }

    var pageStyles = [
      "#offers-layout-block ." + PAGE_PROOF_CLASS + " {",
      "  display: inline-flex;",
      "  align-items: center;",
      "  width: fit-content;",
      "  max-width: 100%;",
      "  gap: 0.55rem;",
      "  margin: 0.35rem 0 1rem;",
      "  padding: 0.55rem 0.78rem;",
      "  border-radius: 999px;",
      "  background: #fff6df;",
      "  color: #1a1a1a;",
      "  font-size: 0.82rem;",
      "  font-weight: 700;",
      "  line-height: 1.25;",
      "  letter-spacing: 0.005em;",
      "  box-shadow: inset 0 0 0 1px rgba(249, 202, 79, 0.78), 0 6px 18px rgba(26, 26, 26, 0.06);",
      "}",
      "#offers-layout-block ." + PAGE_PROOF_CLASS + "::before {",
      "  content: '';",
      "  width: 0.48rem;",
      "  height: 0.48rem;",
      "  flex: 0 0 0.48rem;",
      "  border-radius: 999px;",
      "  background: #f9ca4f;",
      "  box-shadow: 0 0 0 3px rgba(249, 202, 79, 0.28);",
      "}",
      "#offers-layout-block ." + FRAME_OFFER_CLASS + " {",
      "  align-items: center !important;",
      "  border: 1px solid rgba(249, 202, 79, 0.78);",
      "  border-radius: 12px;",
      "  background: #fffaf0;",
      "  box-shadow: 0 5px 16px rgba(26, 26, 26, 0.06);",
      "}",
      "#offers-layout-block ." + FRAME_OFFER_CLASS + " .candyrack-ppp-button-layout__image {",
      "  width: 3.75rem;",
      "  min-width: 3.75rem;",
      "  height: 4.25rem;",
      "  min-height: 4.25rem;",
      "  padding: 0.25rem;",
      "  border-radius: 8px;",
      "  position: relative;",
      "  background: #fff;",
      "  box-sizing: border-box;",
      "  overflow: visible !important;",
      "  box-shadow: inset 0 0 0 1px rgba(26, 26, 26, 0.08);",
      "}",
      "#offers-layout-block ." + FRAME_OFFER_CLASS + " .candyrack-ppp-button-layout__image img {",
      "  display: block;",
      "  max-width: 100%;",
      "  max-height: 3.75rem;",
      "  object-fit: contain;",
      "  border-radius: 5px;",
      "}",
      "#offers-layout-block ." + FRAME_OFFER_CLASS + " .candyrack-ppp-button-layout__info {",
      "  align-items: flex-start;",
      "  gap: 0.12rem;",
      "}",
      "#offers-layout-block ." + FRAME_PROOF_CLASS + " {",
      "  display: block;",
      "  margin: 0.28rem 0 0;",
      "  color: #6b5210;",
      "  font-size: 0.72rem;",
      "  font-weight: 700;",
      "  line-height: 1.35;",
      "  letter-spacing: 0.005em;",
      "}",
      "#offers-layout-block ." + FRAME_PROOF_CLASS + "::before {",
      "  content: '';",
      "  display: inline-block;",
      "  width: 0.42rem;",
      "  height: 0.42rem;",
      "  margin: 0 0.42rem 0.04rem 0;",
      "  border-radius: 999px;",
      "  background: #f9ca4f;",
      "  box-shadow: 0 0 0 3px rgba(249, 202, 79, 0.22);",
      "}",
      "#offers-layout-block ." + FRAME_OFFER_CLASS + " .candyrack-ppp-button {",
      "  min-width: 5.75rem;",
      "  border-radius: 3px;",
      "  font-weight: 700;",
      "  display: grid;",
      "  place-content: center;",
      "}",
      "#offers-layout-block ." + FRAME_OFFER_CLASS + " > :last-child {",
      "  align-self: center !important;",
      "}",
      "@media (max-width: 699px) {",
      "  #offers-layout-block ." + PAGE_PROOF_CLASS + " {",
      "    border-radius: 14px;",
      "    padding: 0.58rem 0.72rem;",
      "  }",
      "  #offers-layout-block ." + FRAME_PROOF_CLASS + " {",
      "    max-width: 17rem;",
      "  }",
      "}"
    ].join("\n");

    if (style.textContent !== pageStyles) {
      style.textContent = pageStyles;
    }
  }

  function ensurePopupStyle(frameDocument) {
    if (!frameDocument || !frameDocument.head) return;

    var style = frameDocument.getElementById(STYLE_ID);
    if (!style) {
      style = frameDocument.createElement("style");
      style.id = STYLE_ID;
      frameDocument.head.appendChild(style);
    }

    var popupStyles = [
      ".cu-candyrack-social-proof {",
      "  display: flex;",
      "  align-items: center;",
      "  width: fit-content;",
      "  max-width: calc(100% - 48px);",
      "  gap: 7px;",
      "  margin: 8px auto 16px;",
      "  padding: 8px 11px;",
      "  border-radius: 999px;",
      "  background: #fff6df;",
      "  color: #1a1a1a;",
      "  font-size: 13px;",
      "  font-weight: 700;",
      "  line-height: 1.35;",
      "  text-align: left;",
      "  box-shadow: inset 0 0 0 1px rgba(249, 202, 79, 0.78), 0 6px 18px rgba(26, 26, 26, 0.06);",
      "}",
      ".cu-candyrack-social-proof::before {",
      "  content: '';",
      "  width: 7px;",
      "  height: 7px;",
      "  flex: 0 0 7px;",
      "  border-radius: 999px;",
      "  background: #f9ca4f;",
      "  box-shadow: 0 0 0 3px rgba(249, 202, 79, 0.28);",
      "}",
      "body.cu-candyrack-frame-in-cart-popup #modal-container {",
      "  opacity: 0;",
      "  pointer-events: none;",
      "}",
      ".cu-candyrack-frame-offer {",
      "  margin: 8px 15px 4px 0 !important;",
      "  padding: 10px 15px !important;",
      "  border: 1px solid rgba(249, 202, 79, 0.78);",
      "  border-radius: 0 12px 12px 0;",
      "  background: #fffaf0;",
      "  box-shadow: 0 5px 16px rgba(26, 26, 26, 0.06);",
      "}",
      ".cu-candyrack-frame-offer [data-cy='offer-product'] {",
      "  align-items: center !important;",
      "  margin-top: 0 !important;",
      "  padding: 0 0 15px !important;",
      "}",
      ".cu-candyrack-frame-offer .Tree__line--horizontal {",
      "  display: none !important;",
      "}",
      ".cu-candyrack-frame-offer [class*='Tree__line'] {",
      "  display: none !important;",
      "}",
      ".cu-candyrack-frame-offer .candyrack-ppp-button-layout__image {",
      "  width: 3.5rem;",
      "  min-width: 3.5rem;",
      "  height: 4.25rem;",
      "  min-height: 4.25rem;",
      "  padding: 0.25rem;",
      "  border-radius: 8px;",
      "  position: relative;",
      "  background: #fff;",
      "  box-sizing: border-box;",
      "  overflow: visible !important;",
      "  box-shadow: inset 0 0 0 1px rgba(26, 26, 26, 0.08);",
      "}",
      ".cu-candyrack-frame-offer .candyrack-ppp-button-layout__image img {",
      "  display: block;",
      "  max-width: 100%;",
      "  max-height: 3.75rem;",
      "  object-fit: contain;",
      "  border-radius: 5px;",
      "}",
      ".cu-candyrack-frame-offer .candyrack-ppp-button-layout__info {",
      "  align-items: flex-start;",
      "  gap: 0.12rem;",
      "}",
      ".cu-candyrack-frame-offer .Offer-Info-Wrapper > div:last-child {",
      "  align-items: flex-start;",
      "}",
      ".cu-candyrack-frame-proof {",
      "  display: block;",
      "  margin: 6px 0 0;",
      "  color: #6b5210;",
      "  font-size: 12px;",
      "  font-weight: 700;",
      "  line-height: 1.3;",
      "  letter-spacing: 0;",
      "}",
      ".cu-candyrack-frame-proof::before {",
      "  content: '';",
      "  display: inline-block;",
      "  width: 0.42rem;",
      "  height: 0.42rem;",
      "  margin: 0 0.42rem 0.04rem 0;",
      "  border-radius: 999px;",
      "  background: #f9ca4f;",
      "  box-shadow: 0 0 0 3px rgba(249, 202, 79, 0.22);",
      "}",
      "@media (max-width: 699px) {",
      "  #modal-container {",
      "    overflow-x: hidden;",
      "  }",
      "  .cu-candyrack-frame-offer {",
      "    width: auto !important;",
      "    margin: 8px 15px 14px !important;",
      "    padding: 10px 14px 14px !important;",
      "    border-radius: 10px !important;",
      "    box-sizing: border-box;",
      "  }",
      "  .cu-candyrack-frame-offer [data-cy='offer-product'] {",
      "    display: block !important;",
      "    padding: 0 0 10px !important;",
      "  }",
      "  .cu-candyrack-frame-offer .Offer-Info-Wrapper {",
      "    display: flex !important;",
      "    align-items: center !important;",
      "    gap: 15px;",
      "    width: 100%;",
      "    margin-bottom: 10px !important;",
      "  }",
      "  .cu-candyrack-frame-offer .Offer-Icon-Wrapper {",
      "    flex: 0 0 5.75rem;",
      "    width: 5.75rem;",
      "    padding-right: 0 !important;",
      "    overflow: visible !important;",
      "  }",
      "  .cu-candyrack-frame-offer .Offer-Icon {",
      "    width: 5.75rem !important;",
      "    height: 6.25rem !important;",
      "    padding: 0.25rem;",
      "    border-radius: 8px;",
      "    position: relative;",
      "    background: #fff;",
      "    box-sizing: border-box;",
      "    overflow: visible !important;",
      "    box-shadow: inset 0 0 0 1px rgba(26, 26, 26, 0.08);",
      "  }",
      "  .cu-candyrack-frame-offer .Offer-Icon img {",
      "    display: block;",
      "    max-width: 100%;",
      "    max-height: 100%;",
      "    object-fit: contain;",
      "  }",
      "  .cu-candyrack-frame-offer .candyrack-ppp-button-layout__image {",
      "    width: 5.75rem;",
      "    min-width: 5.75rem;",
      "    height: 6.25rem;",
      "    min-height: 6.25rem;",
      "  }",
      "  .cu-candyrack-frame-offer .candyrack-ppp-button-layout__image img {",
      "    max-height: 5.75rem;",
      "  }",
      "  .cu-candyrack-frame-offer .Offer-Info-Wrapper,",
      "  .cu-candyrack-frame-offer .candyrack-ppp-button-layout__info {",
      "    min-width: 0;",
      "  }",
      "  .cu-candyrack-frame-offer .Offer-Info-Wrapper > div:last-child {",
      "    flex: 1 1 auto;",
      "    min-width: 0;",
      "  }",
      "  .cu-candyrack-frame-offer .Offer-Title,",
      "  .cu-candyrack-frame-offer .candyrack-ppp-button-layout__info--product-name {",
      "    line-height: 1.25;",
      "  }",
      "  .cu-candyrack-frame-proof {",
      "    max-width: 100%;",
      "    margin-top: 7px;",
      "    font-size: 12px;",
      "    line-height: 1.25;",
      "  }",
      "  .cu-candyrack-frame-offer .Buy-Container {",
      "    display: block !important;",
      "    width: 100%;",
      "    padding-top: 0 !important;",
      "  }",
      "  .cu-candyrack-frame-offer .Buy-Container > div {",
      "    display: block !important;",
      "    width: 100%;",
      "  }",
      "  .cu-candyrack-frame-offer .candyrack-ppp-button,",
      "  .cu-candyrack-frame-offer .Button-Add {",
      "    display: grid !important;",
      "    width: 100% !important;",
      "    min-height: 36px;",
      "    margin-top: 2px;",
      "    place-content: center;",
      "  }",
      "}"
    ].join("\n");

    if (style.textContent !== popupStyles) {
      style.textContent = popupStyles;
    }
  }

  function getFrameDocument(frame) {
    try {
      return frame && (frame.contentDocument || (frame.contentWindow && frame.contentWindow.document));
    } catch (error) {
      return null;
    }
  }

  function normalizeText(value) {
    return (value || "").toString().replace(/\s+/g, " ").trim().toLowerCase();
  }

  function isTrueFrameText(value) {
    var text = normalizeText(value);
    if (!text) return false;

    if (/posterleisten?|leisten?|tesa|powerstrips?|power\s*strips?|klebe|aufhäng|aufhaeng/i.test(text)) {
      return false;
    }

    return /posterrahmen|bilderrahmen|\brahmen\b|frames?\b/i.test(text);
  }

  function getOfferTitle(offer) {
    var name = offer && offer.querySelector(
      ".candyrack-ppp-button-layout__info--product-name, .Offer-Title"
    );

    return name ? name.textContent : "";
  }

  function findFrameOffer(root) {
    var list = root.querySelector(
      ".candyrack-ppp-button-layout__offers--list, ul.Upsell-List, [data-cy-layout='tree']"
    );
    if (!list) return null;

    var offers = Array.prototype.slice.call(list.querySelectorAll(
      "[data-test-id='candyrack-ppp-button-layout__offer'], li.Upsell-Item"
    ));
    return offers.find(function(offer) {
      return isTrueFrameText(getOfferTitle(offer));
    }) || null;
  }

  function findFrameInfo(frameOffer) {
    return frameOffer.querySelector(".candyrack-ppp-button-layout__info") ||
      frameOffer.querySelector(".Offer-Info-Wrapper > div:last-child");
  }

  function decorateFrameOffer(root, ownerDocument) {
    var frameOffer = findFrameOffer(root);
    if (!frameOffer) return false;

    frameOffer.classList.add(FRAME_OFFER_CLASS);

    var info = findFrameInfo(frameOffer);
    if (!info) return false;

    var proofs = Array.prototype.slice.call(root.querySelectorAll("." + FRAME_PROOF_CLASS));
    var proof = proofs.shift();
    if (!proof) {
      proof = ownerDocument.createElement("span");
      proof.className = FRAME_PROOF_CLASS;
    }

    proofs.forEach(function(extraProof) {
      extraProof.remove();
    });

    if (proof.textContent !== MESSAGE) {
      proof.textContent = MESSAGE;
    }
    if (proof.parentElement !== info || info.lastElementChild !== proof) {
      info.appendChild(proof);
    }

    return true;
  }

  function isElementVisible(element) {
    if (!element || !element.isConnected) return false;

    var ownerWindow = element.ownerDocument && element.ownerDocument.defaultView || window;
    var styles = ownerWindow.getComputedStyle(element);
    if (styles.display === "none" || styles.visibility === "hidden" || styles.pointerEvents === "none") {
      return false;
    }
    if (parseFloat(styles.opacity || "1") <= 0.01) return false;

    var rect = element.getBoundingClientRect();
    return rect.width > 2 && rect.height > 2;
  }

  function hasOpenThemeOverlay() {
    if (document.querySelector("dialog[open], .drawer[open], .popover[open]")) return true;

    var overlays = Array.prototype.slice.call(document.querySelectorAll(
      "[aria-modal='true']:not([hidden])"
    ));

    return overlays.some(isElementVisible);
  }

  function isCandyRackPopupActive(frame) {
    frame = frame || document.getElementById("candyrack-frame");
    if (!isElementVisible(frame)) return false;

    var frameDocument = getFrameDocument(frame);
    if (!frameDocument || !frameDocument.body) return true;
    if (frameDocument.body.dataset.cuCandyrackFrameSuppressed === "true") return false;

    var modalContainer = findModalContainer(frameDocument);
    if (!modalContainer || modalContainer === frameDocument.body) return true;

    try {
      return isElementVisible(modalContainer);
    } catch (error) {
      return true;
    }
  }

  function elementHasInlineScrollLock(element) {
    if (!element) return false;

    var style = element.style;
    return style.overflow === "hidden" ||
      style.overflowY === "hidden" ||
      style.position === "fixed" ||
      style.touchAction === "none";
  }

  function clearInlineScrollLock(element) {
    if (!element || !elementHasInlineScrollLock(element)) return false;

    [
      "overflow",
      "overflowX",
      "overflowY",
      "position",
      "top",
      "left",
      "right",
      "width",
      "height",
      "touchAction"
    ].forEach(function(property) {
      element.style[property] = "";
    });

    return true;
  }

  function getLockedScrollY() {
    var bodyTop = parseInt(document.body && document.body.style.top || "", 10);
    var htmlTop = parseInt(document.documentElement.style.top || "", 10);
    var lockedTop = Number.isFinite(bodyTop) && bodyTop < 0 ? bodyTop : htmlTop;

    return Number.isFinite(lockedTop) && lockedTop < 0 ? Math.abs(lockedTop) : window.scrollY;
  }

  function releaseStrandedCandyRackScrollLock() {
    if (isCandyRackPopupActive()) {
      var activeScrollY = getLockedScrollY();
      if (activeScrollY > 0) lastCandyRackScrollY = activeScrollY;
      return false;
    }
    if (hasOpenThemeOverlay()) return false;

    var scrollY = getLockedScrollY();
    if (scrollY <= 0 && lastCandyRackScrollY > 0) {
      scrollY = lastCandyRackScrollY;
    }
    var unlockedHtml = clearInlineScrollLock(document.documentElement);
    var unlockedBody = clearInlineScrollLock(document.body);
    var unlockedLockClass = document.documentElement.classList.contains("lock");
    var unlockedCandyRackClass = document.body.classList.contains("candyrack-body-open");

    if (unlockedLockClass) {
      document.documentElement.classList.remove("lock");
    }
    if (unlockedCandyRackClass) {
      document.body.classList.remove("candyrack-body-open");
    }

    if ((unlockedHtml || unlockedBody || unlockedLockClass || unlockedCandyRackClass) && scrollY > 0) {
      requestAnimationFrame(function() {
        window.scrollTo(0, scrollY);
      });
    }

    if (unlockedHtml || unlockedBody || unlockedLockClass || unlockedCandyRackClass) {
      lastCandyRackScrollY = 0;
      return true;
    }

    return false;
  }

  function scheduleScrollUnlockCheck(delay) {
    clearTimeout(scrollUnlockTimer);
    scrollUnlockTimer = setTimeout(function() {
      scrollUnlockTimer = null;

      if (releaseStrandedCandyRackScrollLock()) {
        scrollUnlockAttempts = 0;
        return;
      }

      scrollUnlockAttempts += 1;
      if (scrollUnlockAttempts < 7) {
        scheduleScrollUnlockCheck(Math.min(250 * Math.pow(1.8, scrollUnlockAttempts), 3500));
      } else {
        scrollUnlockAttempts = 0;
      }
    }, delay || 0);
  }

  function startScrollUnlockChecks(delay) {
    scrollUnlockAttempts = 0;
    scheduleScrollUnlockCheck(delay || 150);
  }

  function isPopupActionClick(target) {
    return !!(target && target.closest && target.closest(
      "button, a, [role='button'], input[type='button'], input[type='submit'], .candyrack-ppp-button, .Button-Add"
    ));
  }

  function bindPopupScrollUnlock(frameDocument, frame) {
    if (!frameDocument || !frameDocument.body || !frame) return;
    if (frameDocument.body.dataset.cuCandyrackScrollUnlockBound === "true") return;

    frameDocument.body.dataset.cuCandyrackScrollUnlockBound = "true";

    frameDocument.addEventListener("click", function(event) {
      if (!isPopupActionClick(event.target)) return;
      startScrollUnlockChecks(350);
    }, true);

    frameDocument.addEventListener("submit", function() {
      startScrollUnlockChecks(350);
    }, true);
  }

  function stylePageSubtitle() {
    var root = document.getElementById("offers-layout-block");
    if (!root || !root.isConnected) return false;

    ensurePageStyle();

    var frameOffer = findFrameOffer(root);
    if (frameOffer) {
      var oldProof = root.querySelector("." + PAGE_PROOF_CLASS) ||
        root.querySelector(".candyrack-ppp-button-layout__offers--subtitle");
      if (oldProof && oldProof.textContent.trim() === MESSAGE) {
        oldProof.remove();
      }

      return decorateFrameOffer(root, document);
    }

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function(node) {
        if (!node || node.nodeValue.trim() !== MESSAGE) return NodeFilter.FILTER_REJECT;

        var parent = node.parentElement;
        if (!parent || parent.closest("a, button, [role='button']")) return NodeFilter.FILTER_REJECT;

        return NodeFilter.FILTER_ACCEPT;
      }
    });

    var textNode = walker.nextNode();
    if (!textNode) return false;

    var parentElement = textNode.parentElement;
    if (parentElement && parentElement.textContent.trim() === MESSAGE) {
      parentElement.classList.add(PAGE_PROOF_CLASS);
    } else {
      var chip = document.createElement("span");
      chip.className = PAGE_PROOF_CLASS;
      textNode.parentNode.insertBefore(chip, textNode);
      chip.appendChild(textNode);
    }

    return true;
  }

  function findModalContainer(frameDocument) {
    return frameDocument.getElementById("modal-container") ||
      frameDocument.querySelector("[aria-modal='true'], [role='dialog'], [class*='Modal'], [class*='modal']") ||
      frameDocument.body;
  }

  function injectIntoPopup(frameDocument, frame) {
    if (!frameDocument || !frameDocument.body) return false;

    ensurePopupStyle(frameDocument);
    bindPopupScrollUnlock(frameDocument, frame);

    if (frame) {
      frame.style.opacity = "";
      frame.style.pointerEvents = "";
    }
    frameDocument.body.classList.remove("cu-candyrack-frame-in-cart-popup");
    delete frameDocument.body.dataset.cuCandyrackFrameSuppressed;

    var modalContainer = findModalContainer(frameDocument);
    var proofs = Array.prototype.slice.call(frameDocument.querySelectorAll("." + PROOF_CLASS));
    proofs.forEach(function(proof) {
      proof.remove();
    });

    return decorateFrameOffer(modalContainer, frameDocument);
  }

  function bindFrame(frame) {
    if (!frame) return;

    if (frame.dataset.cuCandyrackSocialProofBound === "true") {
      injectIntoPopup(getFrameDocument(frame), frame);
      return;
    }

    frame.dataset.cuCandyrackSocialProofBound = "true";

    var attempts = 0;
    function tryInject() {
      var frameDocument = getFrameDocument(frame);
      attempts += 1;

      injectIntoPopup(frameDocument, frame);

      var modalContainer = frameDocument && findModalContainer(frameDocument);
      var frameOfferReady = modalContainer && findFrameOffer(modalContainer);
      if (!frameOfferReady && attempts < 12 && frame.isConnected) {
        setTimeout(tryInject, Math.min(200 * attempts, 1200));
      }
    }

    frame.addEventListener("load", tryInject);
    tryInject();
  }

  function findAndBindFrame() {
    bindFrame(document.getElementById("candyrack-frame"));
  }

  function mutationTouchesCandyRackFrame(mutation) {
    var nodes = Array.prototype.slice.call(mutation.addedNodes || [])
      .concat(Array.prototype.slice.call(mutation.removedNodes || []));

    return nodes.some(function(node) {
      return findCandyRackFrameNode(node);
    });
  }

  function findCandyRackFrameNode(node) {
    if (!node) return null;
    if (node.nodeType === 1 && node.id === "candyrack-frame") return node;
    return node.querySelector ? node.querySelector("#candyrack-frame") : null;
  }

  function mutationTouchesScrollState(mutation) {
    if (mutation.type !== "attributes") return false;

    var target = mutation.target;
    return target === document.documentElement ||
      target === document.body ||
      !!(target.matches && target.matches(".drawer, dialog, [aria-modal='true']"));
  }

  function syncSocialProof() {
    stylePageSubtitle();
    findAndBindFrame();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", syncSocialProof, { once: true });
  } else {
    syncSocialProof();
  }

  new MutationObserver(function(mutations) {
    var childListMutations = mutations.filter(function(mutation) {
      return mutation.type === "childList";
    });

    if (childListMutations.length) {
      syncSocialProof();
    }
    if (childListMutations.some(mutationTouchesCandyRackFrame) || mutations.some(mutationTouchesScrollState)) {
      startScrollUnlockChecks(250);
    }
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["class", "style", "open", "aria-hidden"]
  });

  document.addEventListener("variant:add", function() {
    syncSocialProof();
  });
  document.addEventListener("cart:change", function() {
    syncSocialProof();
    startScrollUnlockChecks(250);
  });
})();
